import { darken as muiDarken, lighten as muiLighten, } from '@material-ui/core/styles';
import { getParsePaletteColor } from './newPalette';
/**
 * get darken coefficient of color
 *
 * @example
 *
 * ```tsx
 * const Darken = styled(Basic)`
 *   background-color: ${darken(palette2('interactive', 'b02'), 0.5)};
 * `;
 * ```
 */
export function darken(
/** color input */
colorInput, 
/** color coefficient to apply */
coefficient) {
    return function (props) {
        var color = typeof colorInput === 'function' ? colorInput(props) : colorInput;
        return muiDarken(color, coefficient);
    };
}
/**
 * get lighten coefficient of color
 *
 * @example
 *
 * ```tsx
 * const Lighten = styled(Basic)`
 *   background-color: ${lighten(palette2('interactive', 'b02'), 0.5)};
 * `;
 * ```
 */
export function lighten(colorInput, coefficient) {
    return function (props) {
        var color = typeof colorInput === 'function' ? colorInput(props) : colorInput;
        return muiLighten(color, coefficient);
    };
}
/**
 * get color from palette, and contrast color defined in mui
 * @param props props
 *
 * @example
 * ```ts
 * const [currColor, contrastBgColor] = getContrastBgColor(props);
 * ```
 */
export var getContrastBgColor = function (_a) {
    var theme = _a.theme, color = _a.color;
    var currColor = getParsePaletteColor(color);
    return [
        currColor,
        theme.palette.type === 'light'
            ? /** those contrast value follow mui color */
                lighten(currColor, 0.62)
            : darken(currColor, 0.5),
    ];
};
